"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardTelemetryService = exports.DashboardResourceTelemetryType = exports.CreateNewResourceTelemetryType = void 0;
var snakeCase_1 = __importDefault(require("lodash/snakeCase"));
var ProjectTypes_1 = require("Project/ProjectTypes");
var mobx_1 = require("mobx");
var SearchDropdown_1 = require("Common/Navigation/Search/SearchDropdown");
var Telemetry_1 = require("@CommonFrontendBackend/Telemetry");
var DashboardTypes_1 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var CreateNewResourceTelemetryType;
(function (CreateNewResourceTelemetryType) {
    CreateNewResourceTelemetryType["BlankPage"] = "blank_page";
    CreateNewResourceTelemetryType["PageFromTemplate"] = "page_from_template";
    CreateNewResourceTelemetryType["Folder"] = "folder";
})(CreateNewResourceTelemetryType = exports.CreateNewResourceTelemetryType || (exports.CreateNewResourceTelemetryType = {}));
var DashboardResourceTelemetryType;
(function (DashboardResourceTelemetryType) {
    DashboardResourceTelemetryType["Pages"] = "pages";
    DashboardResourceTelemetryType["Blocks"] = "blocks";
})(DashboardResourceTelemetryType = exports.DashboardResourceTelemetryType || (exports.DashboardResourceTelemetryType = {}));
var DashboardTelemetryService = (function () {
    function DashboardTelemetryService(telemetry) {
        this.telemetry = telemetry;
    }
    DashboardTelemetryService.prototype.startTrackingFilter = function (projectListStore) {
        var _this = this;
        this.stopTrackingFilter();
        this.disposeFilterReaction = (0, mobx_1.reaction)(function () { return projectListStore.filter; }, function (filter) {
            _this.trackFiltersFromReaction(filter);
        });
    };
    DashboardTelemetryService.prototype.stopTrackingFilter = function () {
        if (this.disposeFilterReaction) {
            this.disposeFilterReaction();
            this.disposeFilterReaction = undefined;
        }
    };
    DashboardTelemetryService.prototype.trackOpenProjectIntent = function () {
        var _a;
        this.telemetry.trackOnly(Telemetry_1.TelemetryEventName.ProjectOpenIntent, (_a = {}, _a["".concat((0, snakeCase_1.default)(Telemetry_1.TelemetryEventName.ProjectOpenIntent), "_source")] = TelemetryEnums_1.TelemetrySource.Dashboard, _a), { blockIntercom: true, includeAuthAttrs: true });
    };
    DashboardTelemetryService.prototype.trackSearchFilter = function (triggerType) {
        this.trackFilter("search", triggerType);
    };
    DashboardTelemetryService.prototype.trackViewBlueprintChildren = function () {
        this.telemetry.trackOnly(Telemetry_1.TelemetryEventName.ViewBlueprintChildren, {}, {
            blockIntercom: true,
        });
    };
    DashboardTelemetryService.prototype.trackCreateNewClicked = function () {
        this.telemetry.trackOnly(Telemetry_1.TelemetryEventName.DashboardCreateNewClicked, {}, { blockIntercom: true });
    };
    DashboardTelemetryService.prototype.trackCreateNewResourceClicked = function (resourceType) {
        this.telemetry.trackOnly(Telemetry_1.TelemetryEventName.DashboardCreateNewResourceClicked, { resource_type: resourceType }, { blockIntercom: true });
    };
    DashboardTelemetryService.prototype.trackDashboardViewed = function (resourceType) {
        this.telemetry.trackOnly(Telemetry_1.TelemetryEventName.DashboardViewed, { dashboard_resource_type: resourceType }, { blockIntercom: true });
    };
    DashboardTelemetryService.prototype.trackRememberedFolder = function (folder) {
        var properties = {
            remembered_folder_type: this.getFolderTelemetryName(folder),
        };
        this.telemetry.trackOnly(Telemetry_1.TelemetryEventName.DashboardRememberedFolder, properties, {
            blockIntercom: true,
        });
    };
    DashboardTelemetryService.prototype.trackDashboardFolderSelected = function (folder) {
        var filter = this.getFolderTelemetryName(folder);
        this.trackFilter(filter);
    };
    DashboardTelemetryService.prototype.trackFilter = function (filter, triggerType) {
        if (triggerType === void 0) { triggerType = SearchDropdown_1.TriggerType.Click; }
        var properties = {
            dashboard_filtered_by: filter,
            dashboard_filtered_trigger: triggerType,
        };
        this.telemetry.trackOnly(Telemetry_1.TelemetryEventName.DashboardFiltered, properties, {
            blockIntercom: true,
        });
    };
    DashboardTelemetryService.prototype.getFolderTelemetryName = function (folder) {
        switch (folder) {
            case DashboardTypes_1.ProjectCollection.Archived:
                return "archived";
            case DashboardTypes_1.ProjectCollection.Deleted:
                return "deleted";
            case DashboardTypes_1.ProjectCollection.All:
                return "pages";
            default:
                return "custom folder";
        }
    };
    DashboardTelemetryService.prototype.trackFiltersFromReaction = function (filter) {
        var status = filter.status, tags = filter.tags, user = filter.user;
        if (user.length > 0) {
            this.trackFilter("people");
        }
        if (tags.length > 0) {
            this.trackFilter("tag");
        }
        if (status.length > 0) {
            if (status.includes(ProjectTypes_1.SpecialProjectTag.Starred)) {
                this.trackFilter("status starred");
            }
            if (status.includes(Types_1.ProjectStatus.Draft)) {
                this.trackFilter("status draft");
            }
            if (status.includes(Types_1.ProjectStatus.Live)) {
                this.trackFilter("status live");
            }
            if (status.includes(Types_1.ProjectStatus.Accepted)) {
                this.trackFilter("status accepted");
            }
        }
    };
    return DashboardTelemetryService;
}());
exports.DashboardTelemetryService = DashboardTelemetryService;
